var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    { attrs: { "no-gutters": "" } },
    [
      _c(
        "v-col",
        { staticClass: "pa-0", attrs: { cols: "12" } },
        [
          _vm.$store.state.accounts.LoaderMe ||
          _vm.$store.state.summaries.retrieveLoader
            ? _c("skeleton-list")
            : [
                !_vm.$helpers.hasSomePermission(["view_summary"])
                  ? _c("PermissionDenied")
                  : [
                      !_vm.documentsList.length ||
                      (!_vm.routeList.includes(_vm.$route.name) &&
                        !Object.keys(_vm.$route?.query).length)
                        ? _c("v-empty-state", {
                            key: _vm.$route.name,
                            attrs: {
                              type: "documents",
                              id: "documentos",
                              customClass: "mt-2",
                              isFree: _vm.routeList.includes(_vm.$route.name),
                              title: "No existen documentos para mostrar",
                              hiddenDescription: _vm.hiddenBtnEmpty,
                              height: _vm.routeList.includes(_vm.$route.name)
                                ? 159
                                : 199,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "actions",
                                  fn: function () {
                                    return [
                                      !_vm.routeList.includes(
                                        _vm.$route.name
                                      ) && _vm.hiddenBtnEmpty
                                        ? [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  color: "grey-900",
                                                  ripple: false,
                                                  width: 153,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.$emit(
                                                      "activeBtnFilter"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { staticClass: "mr-2" },
                                                  [_vm._v("mdi-filter-plus")]
                                                ),
                                                _vm._v("Filtrar"),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "ml-2",
                                                attrs: {
                                                  outlined: "",
                                                  ripple: false,
                                                  width: "153",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.latestRecords()
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { staticClass: "mr-2" },
                                                  [
                                                    _vm._v(
                                                      "mdi-text-search-variant"
                                                    ),
                                                  ]
                                                ),
                                                _vm._v("Últimos registros"),
                                              ],
                                              1
                                            ),
                                          ]
                                        : _vm._e(),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              1633689393
                            ),
                          })
                        : [
                            _c("v-data-table", {
                              class: [
                                {
                                  "table-not-rounded": [
                                    "BranchRetrieveUpdate",
                                    "PosRetrieveUpdate",
                                    "DocumentsRetrieve",
                                    "CustomerRetrieveUpdate",
                                  ].includes(_vm.$route.name),
                                },
                                {
                                  "fixed-table":
                                    _vm.$store.state.base
                                      .isExpandNavigationDrawer,
                                },
                              ],
                              staticStyle: { cursor: "pointer" },
                              attrs: {
                                headers: _vm.headerList,
                                items: _vm.documentsList,
                                "items-per-page":
                                  _vm.pageSize || _vm.pagination,
                                "hide-default-header": "",
                                "disable-sort": "",
                                "hide-default-footer": "",
                                "mobile-breakpoint": "300",
                                "item-key": "id",
                                "show-select": false,
                                "checkbox-color": "grey-900",
                                "fixed-header": "",
                                height: _vm.heightTable,
                              },
                              on: {
                                "click:row": (documentsList) => {
                                  _vm.goTo(documentsList.id)
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function ({ props: { headers } }) {
                                      return [
                                        _c("VTableHeaders", {
                                          attrs: {
                                            headers: headers,
                                            resetCheckbox: _vm.resetCheckbox,
                                          },
                                          on: {
                                            sort: _vm.setSort,
                                            toggleAll: _vm.toggleAll,
                                            isSelected: function ($event) {
                                              _vm.isSelected = $event
                                            },
                                            toggleDropdown: function ($event) {
                                              _vm.toggleDropdown = $event
                                            },
                                          },
                                        }),
                                        _c("v-divider", {
                                          staticStyle: {
                                            position: "absolute",
                                            "margin-top": "-6px",
                                            "min-width": "100%",
                                            "margin-left": "-5px",
                                            "z-index": "2",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.type`,
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "green-500--text text-decoration-none",
                                            attrs: {
                                              to: {
                                                name: "DocumentsRetrieve",
                                                params: {
                                                  ..._vm.$route.params,
                                                  id: item.id,
                                                },
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                class: _vm.routeList.includes(
                                                  _vm.$route.name
                                                )
                                                  ? "body-2"
                                                  : "body-1",
                                                staticStyle: {
                                                  "white-space":
                                                    "normal !important",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.currentType(item.type)
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.serial`,
                                    fn: function ({ item }) {
                                      return [
                                        _c("span", { staticClass: "body-2" }, [
                                          _vm._v(
                                            _vm._s(item.type.slice(2, 4)) +
                                              "-" +
                                              _vm._s(
                                                _vm._f("dateLigth")(item.date)
                                              ) +
                                              "-" +
                                              _vm._s(item.serial)
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.reference_date`,
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            class: _vm.routeList.includes(
                                              _vm.$route.name
                                            )
                                              ? "body-2"
                                              : "body-1",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("date")(
                                                  item.reference_date
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.date`,
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            class: _vm.routeList.includes(
                                              _vm.$route.name
                                            )
                                              ? "body-2"
                                              : "body-1",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm._f("date")(item.date))
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.created`,
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            class: _vm.routeList.includes(
                                              _vm.$route.name
                                            )
                                              ? "body-2"
                                              : "body-1",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("dateTimeSecond")(
                                                  item.created
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.status`,
                                    fn: function ({ item }) {
                                      return [
                                        _c("chip-status", {
                                          attrs: {
                                            status: item.status
                                              ? item.status
                                              : "CRE",
                                            detail:
                                              item?.agency_status_detail_list ||
                                              item?.agency_status_info
                                                ? `${
                                                    _vm.setTooltip(
                                                      item.agency_status_detail_list
                                                    ) || item.agency_status_info
                                                  }`
                                                : null,
                                            isTooltip: true,
                                            isActivePopover: true,
                                            type: "summaries",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.actions`,
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "v-menu",
                                          {
                                            attrs: {
                                              "close-on-click": "",
                                              "close-on-content-click": "",
                                              "offset-y": "",
                                              left: "",
                                              "nudge-left": 10,
                                              "nudge-bottom": 10,
                                              transition: "slide-y-transition",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              staticClass:
                                                                "mr-n4",
                                                              attrs: {
                                                                text: "",
                                                                "x-small": "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.current =
                                                                      item
                                                                  },
                                                              },
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  "grey-700",
                                                                size: "24",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-dots-vertical"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c(
                                              "v-list",
                                              { staticClass: "pa-0" },
                                              [
                                                _c(
                                                  "v-list-item",
                                                  {
                                                    staticClass: "px-3",
                                                    attrs: { ripple: false },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.downloadFile2(
                                                          "summaries",
                                                          _vm.nameXML,
                                                          null,
                                                          "xml",
                                                          item.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-item-title",
                                                      {
                                                        staticClass:
                                                          "body-1 grey-500--text d-flex align-center",
                                                      },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              color: "grey-700",
                                                              size: "20",
                                                              left: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-code-braces-box"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          "Descargar documento"
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                ["APR", "OBS"].includes(
                                                  item.status
                                                )
                                                  ? _c(
                                                      "v-list-item",
                                                      {
                                                        staticClass: "px-3",
                                                        attrs: {
                                                          ripple: false,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.downloadFile2(
                                                              "documents",
                                                              `${item.type}_${item.number}`,
                                                              null,
                                                              "voucher",
                                                              item.id
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          {
                                                            staticClass:
                                                              "body-1 grey-500--text d-flex align-center",
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "grey-700",
                                                                  size: "20",
                                                                  left: "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-code-braces-box"
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(
                                                              "Descargar CDR"
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                              model: {
                                value: _vm.selected,
                                callback: function ($$v) {
                                  _vm.selected = $$v
                                },
                                expression: "selected",
                              },
                            }),
                            _vm.showPagination || _vm.showAll
                              ? _c("VMainPagination", {
                                  attrs: {
                                    title: "Resúmenes",
                                    titleShowAll: "Ver todos los documentos",
                                    count: _vm.count,
                                    pageSize: _vm.pageSize,
                                    redirect: "summariesList",
                                  },
                                })
                              : _vm._e(),
                          ],
                    ],
              ],
          _c(
            "v-dialog",
            {
              attrs: {
                width: "700",
                persistent: "",
                scrollable: "",
                "no-click-animation": "",
                "overlay-color": "grey-500",
              },
              model: {
                value: _vm.modalRender,
                callback: function ($$v) {
                  _vm.modalRender = $$v
                },
                expression: "modalRender",
              },
            },
            [
              _c("render-pdf", {
                key: _vm.current.number,
                attrs: {
                  basicRender: true,
                  documentType: _vm._f("nameDocumentsType")(_vm.current.type),
                  number: _vm.current.number,
                  loaderRender: _vm.loaderRender,
                  renderUrl: _vm.renderUrl,
                  formatPDF: _vm.formatPDF,
                  showFormat: true,
                },
                on: {
                  close: function ($event) {
                    _vm.modalRender = false
                  },
                  "update:formatPDF": function ($event) {
                    _vm.formatPDF = $event
                  },
                  "update:format-p-d-f": function ($event) {
                    _vm.formatPDF = $event
                  },
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }